import classes from "../classes";
import payouts from "../payouts";
import pure from "./higher-order/pure";
import React from "react";
import SurvivorGraph from "./survivor-graph";

export default pure(function TournamentStats({ myTickets, races, tokenTypes, tournament }) {
  var finalRace = tournament.get("races").map((raceId) => races.get(raceId)).find((race) => race.get("status") === "final");
  if (!finalRace) {
    return null;
  }

  if (tournament.get("tournament_type") === "Survivor") {
    return <SurvivorStats myTickets={myTickets} tokenTypes={tokenTypes} tournament={tournament} />;
  } else {
    return <ClassicStats myTickets={myTickets} tokenTypes={tokenTypes} tournament={tournament} />;
  }
});

var ClassicStats = pure(function ClassicStats({ myTickets, tokenTypes, tournament }) {
  var payoutsPerPlace = payouts(tournament, tokenTypes);
  var lowestScoringPlace = Object.keys(payoutsPerPlace)
    .map((place) => parseInt(place))
    .reduce((a, b) => Math.max(a, b));

  var totalEntries = tournament.get("tickets").count();

  var inTheMoneyPercent = Math.round(lowestScoringPlace / totalEntries * 100.0);
  var loserPercent = 100 - inTheMoneyPercent;

  var leaderTicket = tournament.get("rankedTickets").first();
  var lastMoneyTicket = tournament.get("rankedTickets").get(lowestScoringPlace - 1) || tournament.get("rankedTickets").last();

  return (
    <div className="survivor-stats">
      <TicketMarkers myTickets={myTickets} tokenTypes={tokenTypes} tournament={tournament} />

      <ul className="survivor-stats_graph">
        <li className="survivor-stats_cell survivor-stats_cell--winner" style={{"width": inTheMoneyPercent + "%"}}>
          {leaderTicket.get("score")}
        </li>

        <li className="survivor-stats_cell" style={{"width": loserPercent + "%"}}>
          {lastMoneyTicket.get("score")}
        </li>
      </ul>
    </div>
  );
});

var TicketMarkers = pure(function TicketMarkers({ myTickets, tokenTypes, tournament }) {
  var payoutsPerPlace = payouts(tournament, tokenTypes);
  var lowestScoringPlace = Object.keys(payoutsPerPlace)
    .map((place) => parseInt(place))
    .reduce((a, b) => Math.max(a, b));

  var totalEntries = tournament.get("tickets").count();

  var ticketElems = myTickets.valueSeq().map((ticket) => {
    var rankedTicket = tournament.get("rankedTickets").find((t) => t.get("id") === ticket.get("id"));
    if (!rankedTicket) {
      return null;
    }
    var rank = rankedTicket.get("rank");
    var ticketPos = Math.round((rank - 1) / (totalEntries - 1) * 100.0);
    var eliminated = rankedTicket.get("eliminated_by_race_id") !== null;
    return (
      <li
        className={classes({
          "survivor-stats_mark": true,
          "survivor-stats_mark--winner": !eliminated && rank <= lowestScoringPlace,
          "survivor-stats_mark--eliminated": eliminated
        })}
        data-ticket-number={ticket.get("ticket_number")}
        key={ticket.get("id")}
        style={{"left": ticketPos + "%"}}>
        <span className="dw-ticket-solid" />
      </li>
    );
  });

  return (
    <ul className="survivor-stats_markers">
      {ticketElems}
    </ul>
  );
});

var SurvivorStats = pure(function SurvivorStats({ myTickets, tokenTypes, tournament}) {
  var totalEntries = tournament.get("tickets").count();
  var survivors = tournament.get("rankedTickets").count((ticket) => ticket.get("eliminated_by_race_id") === null);
  var eliminated = tournament.get("rankedTickets").count((ticket) => ticket.get("eliminated_by_race_id") !== null);
  return (
    <div className="survivor-stats survivor-stats--inline">
      <TicketMarkers myTickets={myTickets} tokenTypes={tokenTypes} tournament={tournament} />

      <SurvivorGraph eliminated={eliminated} short survivors={survivors} total={totalEntries} />
    </div>
  );
});
